import fr from '@/i18n/fr.json'
import en from '@/i18n/en.json'

export default { fr, en }
